import { HeadySparkle } from '@sparemin/blockhead';
import React from 'react';
import { DestinationPlatformMap } from 'blocks/DestinationPlatforms';
import { EmailOutput, RSS } from 'components/icons';
import { AutogramClipSelectionMethod } from 'types';
import { AutomationOptionsCardsOptions, AutoPostOptions } from './types';
import { block } from './utils';

export const DEFAULT_EMAIL_POSTING_OPTION: AutomationOptionsCardsOptions = {
  id: 'email',
  contents: (
    <>
      <strong>Email videos to me</strong> so I can
      <br />
      manually post them myself
    </>
  ),
  icon: <EmailOutput width="70" />,
  value: {
    automationOption: AutoPostOptions.EMAIL,
  },
};

export const DEFAULT_CLIP_SELECTION_OPTIONS: AutomationOptionsCardsOptions[] = [
  {
    id: 'headliner-ai',
    contents: (
      <>
        <strong>Let Headliner AI select clips</strong> that I can easily adjust
        later
      </>
    ),
    icon: (
      <div className={block('icon')}>
        <HeadySparkle fontSize={48} />
      </div>
    ),
    value: {
      clipSelectionMethod: AutogramClipSelectionMethod.SMART,
    },
    size: 'large',
  },
  {
    id: 'soundbite-tags',
    contents: (
      <>
        <strong>Use Soundbite tags</strong> that I'll manually add to my RSS
        feed
      </>
    ),
    icon: (
      <div className={block('icon', { small: true })}>
        <RSS fill="#6E6EDE" height={24} width={24} />
      </div>
    ),
    value: {
      clipSelectionMethod: AutogramClipSelectionMethod.SOUNDBITE_TAG,
    },
    size: 'small',
  },
];

export const AUTO_POSTING_PLATFORM_NAME_MAP: DestinationPlatformMap<string> = {
  youtube: 'YouTube',
  tiktok: 'TikTok',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  facebook: 'Facebook',
  twitter: 'X',
  threads: 'Threads',
  bluesky: 'Bluesky',
};
